var React = require('react');

function ChevronDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M3.495 8.538l8.447 8.602 8.446-8.602","fill":"none","strokeLinecap":"square","strokeLinejoin":"round"}));
}

ChevronDownInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ChevronDownInline;

ChevronDownInline.default = ChevronDownInline;
